export const DEFAULT_RELAYS = ['wss://nostr.mom/']
export const GLOBAL_DEFAULTS = {
    PRODUCTURL: '/product/$PRODUCTNAME/$PRODUCTID',
}
